import React from "react";
import "./Events.css";
import Card from "./EventCard";
import Data from "./EventData";
import Title from "../Title/Title"
const Events = () => {
  return (
    <>
      <div id="event-heading">
      <Title title={"Events"} id="event-heading"/>
      </div>
      <div className="container">
      <div className="card__container">
        {
          Data.map((event)=>{
            return (
              <Card 
              title={event.title}
              iconClass={event.iconClass} 
              hue1={event.hue1} 
              hue2={event.hue2} 
              id={event.id}
              img={event.img}
            />
            )
          })
        }
      </div>
    </div>
    </>
  );
};

export default Events;
